export default __webpack_public_path__ + "8b268ca78c1574fe047dea00b3e95bcc.png";